export default "__VITE_ASSET__DHjW42WF__"